import type { GetterTree } from "vuex";
import type {
  SelfDataState,
  Building,
  Variable,
  DownloadConfig,
  DownloadRequest,
  RootState,
} from "@/types";
import type { VariableHistory } from "@/types/selfData";

export const getters: GetterTree<SelfDataState, RootState> = {
  // BUILDINGS
  getBuildingsData(state): Building[] {
    return state.buildings.data;
  },
  getBuildingsLoading(state): boolean {
    return state.buildings.loading;
  },
  getBuildingsError(state): string | null {
    return state.buildings.error;
  },
  // VARIABLES
  getVariablesData(state): Variable[] {
    return state.variables.data;
  },
  getVariablesCount(state): number {
    return state.variables.count;
  },
  getVariablesLoading(state): boolean {
    return state.variables.loading;
  },
  getVariablesError(state): string | null {
    return state.variables.error;
  },

  // VARIABLES EXPORT

  getVariablesExportLoading(state): boolean {
    return state.variablesExport.loading;
  },
  getVariablesExportError(state): string | null {
    return state.variablesExport.error;
  },

  // IMPORTS
  getImportsData(state): any[] {
    return state.imports.data;
  },
  getImportsCount(state): number {
    return state.imports.count;
  },
  getImportsLoading(state): boolean {
    return state.imports.loading;
  },
  getImportsError(state): string | null {
    return state.imports.error;
  },
  // DOWNLOAD_CONFIGS
  getDownloadConfigsData(state): DownloadConfig[] {
    return state.downloadConfigs.data;
  },
  getDownloadConfigsLoading(state): boolean {
    return state.downloadConfigs.loading;
  },
  getDownloadConfigsError(state): string | null {
    return state.downloadConfigs.error;
  },
  // DOWNLOAD_REQUEST
  getDownloadRequestLoading(state): boolean {
    return state.downloadRequest.loading;
  },
  getDownloadRequestError(state): string | null {
    return state.downloadRequest.error;
  },
  // FILES
  getFilesData(state): DownloadRequest[] {
    return state.files.data;
  },
  getFilesLoading(state): boolean {
    return state.files.loading;
  },
  getFilesError(state): string | null {
    return state.files.error;
  },
  // History VARIABLES change
  getHistoryVariablesChangeData(state): VariableHistory[] {
    return state.historyVariableChange.data;
  },
  getHistoryVariablesChangeCount(state): number {
    return state.historyVariableChange.count;
  },
  getHistoryVariablesChangeLoading(state): boolean {
    return state.historyVariableChange.loading;
  },
  getHistoryVariablesChangeError(state): string | null {
    return state.historyVariableChange.error;
  },
};
